'use client';

import { useFormContext, useWatch } from 'react-hook-form';

import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import type {
  Persona,
  RegisterFormInput,
} from '@eliadmin/core/src/components/dlz/auth/register/register-schema';
import { Segmented } from '@eliadmin/core/src/components/dlz/ui/segmented';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/**
 * Figma „Registrujem sa ako“ (60260:28430): the light segmented control, two rows on phones. The
 * shared form keeps everything typed while the persona changes; errors of the other persona go.
 */
export function PersonaCard() {
  const { t } = useTranslations();
  const { control, setValue, clearErrors } = useFormContext<RegisterFormInput>();
  const persona = useWatch({ control, name: 'persona' });

  const select = (value: Persona) => {
    clearErrors();
    setValue('persona', value);
  };

  return (
    <RegisterCard title={REGISTER_COPY.persona.title} first>
      <Segmented<Persona>
        label={REGISTER_COPY.persona.label}
        value={persona}
        onChange={select}
        tone="light"
        className="flex-col rounded-3xl md:flex-row md:rounded-full [&>button]:flex-none md:[&>button]:flex-1"
        options={[
          { value: 'individual', label: t('text2234'), icon: 'user' },
          { value: 'company', label: REGISTER_COPY.persona.company, icon: 'briefcase' },
        ]}
      />
    </RegisterCard>
  );
}
